import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';

export function AppLayout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <div className="min-h-screen bg-canvas-50 text-ink-900">
      <header className="sticky top-0 z-30 border-b border-ink-900/5 bg-canvas-50/85 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/" className="group flex items-center gap-3">
            <Logo />
            <div className="leading-tight">
              <div className="font-display text-lg font-semibold tracking-tight">
                Elias's Gallery
              </div>
              <div className="text-xs text-ink-500">A growing collection of original artwork</div>
            </div>
          </Link>
          <nav className="flex items-center gap-1">
            <NavItem to="/" end>Gallery</NavItem>
            <NavItem to={isAdmin ? '/admin/dashboard' : '/admin'}>Admin</NavItem>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10">
        <Outlet />
      </main>
      <footer className="mx-auto max-w-6xl px-6 py-12 text-center text-sm text-ink-500">
        <p>
          Made with love for Elias's art. {new Date().getFullYear()}.
        </p>
      </footer>
    </div>
  );
}

function NavItem({
  to,
  end,
  children,
}: {
  to: string;
  end?: boolean;
  children: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
          isActive
            ? 'bg-ink-900 text-canvas-50'
            : 'text-ink-700 hover:bg-canvas-100'
        }`
      }
    >
      {children}
    </NavLink>
  );
}

function Logo() {
  return (
    <span className="grid h-9 w-9 place-items-center rounded-xl bg-ink-900 text-canvas-50 transition-transform group-hover:rotate-3">
      <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
        <circle cx="9" cy="9" r="3" fill="#d4451c" />
        <circle cx="16" cy="8" r="2.2" fill="#f4a261" />
        <path d="M4 19 L11 11 L20 19 Z" fill="currentColor" />
      </svg>
    </span>
  );
}
